module.exports = __webpack_public_path__ + "static/media/not-serious.a2158b66.png";